import { forwardRef } from "react";
import { Link } from "react-router-dom";

import "./CourseSearchResults.css";
import { getCourseSlug, normalizeText } from "../../utils/slugUtils";
import { stripHtml } from "../../utils/textUtils";
import handleCourseClick from "../../helper/handleCourseClick";

const CourseSearchResults = forwardRef(function CourseSearchResults(
  {
    courses = [],
    totalCourses = 0,
    currentPage = 1,
    totalPages = 1,
    isLoading = false,
    searchTerm = "",
    searchInput = "",
    onSearchInputChange,
    onSearch,
    onSearchKeyDown,
    onRequestQuote,
    onPageChange,
  },
  ref
) {
  const hasCourses = courses.length > 0;

  function goToPreviousPage() {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  }

  function goToNextPage() {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  }

  return (
    <section className="section" id="courses" ref={ref}>
      <p className="eyebrow">Training Catalog</p>
      <h2>Course Search Results</h2>

      <div className="results-search">
        <input
          type="text"
          placeholder="Search courses..."
          value={searchInput}
          disabled={isLoading}
          onChange={(event) => onSearchInputChange(event.target.value)}
          onKeyDown={onSearchKeyDown}
        />

        <button
          type="button"
          disabled={isLoading}
          onClick={onSearch}
        >
          {isLoading ? "Searching..." : "Search"}
        </button>
      </div>

      {isLoading ? (
        <p>Course is loading...</p>
      ) : searchTerm ? (
        <p>
          Found <strong>{totalCourses}</strong> result(s) for{" "}
          <strong>{searchTerm}</strong>
        </p>
      ) : (
        <p>
          Showing page {currentPage} of {totalPages}. Displaying{" "}
          {courses.length} courses from {totalCourses} total available
          course records.
        </p>
      )}

      {!isLoading && !hasCourses && (
        <p>No course records found.</p>
      )}

      <div className="course-grid">
        {!isLoading &&
          courses.map((course) => {
            const courseTitle = normalizeText(
              course.post_title ||
                course.title ||
                "Course"
            );

            const cleanDescription = normalizeText(
              stripHtml(course.post_content || "")
            );

            const description =
              cleanDescription.length > 120
                ? `${cleanDescription.substring(0, 120)}...`
                : cleanDescription;

            return (
              <article
                key={course._id}
                className="course-card"
              >
                <h3>{courseTitle}</h3>

                <p>{description}</p>

                <div className="course-card-actions">
                  <Link
                    to={`/courses/${getCourseSlug(course)}`}
                    className="course-details-button"
                    onClick={(event) => {
                      event.stopPropagation();

                      handleCourseClick(course);
                    }}
                  >
                    View Course
                  </Link>

                  {onRequestQuote && (
                    <button
                      type="button"
                      className="course-details-button"
                      onClick={(event) => {
                        event.stopPropagation();

                        onRequestQuote(course);
                      }}
                    >
                      Request Quote
                    </button>
                  )}
                </div>
              </article>
            );
          })}
      </div>

      {!isLoading && totalPages > 1 && (
        <div className="pagination">
          <button
            type="button"
            disabled={currentPage <= 1}
            onClick={goToPreviousPage}
          >
            Previous
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            type="button"
            disabled={currentPage >= totalPages}
            onClick={goToNextPage}
          >
            Next
          </button>
        </div>
      )}
    </section>
  );
});

export default CourseSearchResults;